export class TypeMap {
    constructorsByJsonapiType = {};
    get(typeName) {
        return this.constructorsByJsonapiType[typeName];
    }
    set(typeName, constructorType) {
        this.constructorsByJsonapiType[typeName] = constructorType;
    }
    remove(typeName, ...typeNames) {
        [typeName, ...typeNames].forEach((someType) => {
            delete this.constructorsByJsonapiType[someType];
        });
    }
}
export const ENTITIES_MAP = new TypeMap();
export function getClassForJsonapiType(type) {
    return ENTITIES_MAP.get(type);
}
// eslint-disable-next-line @typescript-eslint/ban-types
export function getConstructorForJsonapiType(type) {
    const clazz = getClassForJsonapiType(type);
    return clazz && clazz.prototype && clazz.prototype.constructor;
}
export function registerEntityConstructorForType(constructor, type) {
    const existingConstructor = ENTITIES_MAP.get(type);
    if (!existingConstructor) {
        ENTITIES_MAP.set(type, constructor);
        return true;
    }
    else if (existingConstructor === constructor) {
        return false;
    }
    throw new Error(`Attempt to reregister JSON:API type '${type}' to the entity constructor type: ${constructor.name}`);
}
export function isEntityConstructorRegistered(constructor) {
    const instance = new constructor();
    return ENTITIES_MAP.get(instance.type) ? true : false;
}
/**
 * Annotates a class to indicate that it is a JSON:API entity definition.
 *
 * Any class annotated with `@entity` should be considered serialisable to JSON:API,
 * and should have `@attribute` and `@relationship` decorators to indicate properties
 * to be serialisable to and deserialisable from appropriate JSON:API data.
 *
 */
/* eslint-disable @typescript-eslint/no-explicit-any -- constructor types cannot be known */
export function entity(options) {
    /* eslint-enable @typescript-eslint/no-explicit-any */
    const { type } = options;
    return (original) => {
        original.prototype.type = type;
        // add the type to the reverse lookup for deserialisation
        registerEntityConstructorForType(original, type);
        return original;
    };
}
